module.exports = __webpack_public_path__ + "img/payment-card.144497a2.svg";